import {Dispatch} from "react";
import {IAction} from "src/context/IAction";
import {Region} from "src/context/models/Session";
import {SET_REGION_SUCCESS} from "src/context/actions/ActionTypes";

export function setRegionAction(dispatch: Dispatch<IAction>, region: Region) {
    dispatch({
        type: SET_REGION_SUCCESS,
        payload: region
    });
}